// extracted by mini-css-extract-plugin
export var btnInfo = "sectionHeadingDescription-module--btn-info--03a16";
export var descriptionContainer2 = "sectionHeadingDescription-module--description-container-2--cef93";
export var principleContainer = "sectionHeadingDescription-module--principle-container--4f86b";
export var richContainer = "sectionHeadingDescription-module--rich-container--8bd39";
export var textContainer = "sectionHeadingDescription-module--text-container--bf9f2";